import { LitElement, html, css } from 'lit';
import { accessibility, grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { getStatus } from '../../utilities/orgUtilities';
import { decodeEntities, checkFormLock } from '../../utilities/formsUtilities';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInConditionals } from '../Utilities/AllInConditionals';
import { AllInLocationsBase } from '../Utilities/AllInLocationsBase';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
//import arrowUrl from '../../../../../../assets/arrow.svg?url';
export class AllInLocations extends AllInLocationsBase(AllInConditionals(AllInSessionStorage(AllInOrganisationConsumer(LitElement)))) {
    static properties = {
        ...super.properties,
        _loading: { state: true, type: Boolean },
        _locationData: { state: true, type: Array },
        _isApproved: { state: true, type: Boolean },
        //_hasZones: {state:true,type: Boolean},
    };
    constructor() {
        super();
        this._loading = true;
        //this._hasZones = true;
    }
    async connectedCallback() {
        super.connectedCallback();
        this._loading = true;
        if (this.organisation?.hasOwnProperty('locations')) {
            this._locationData = this.organisation.locations;
            this._loading = false;
        }
        else if (this.currentOrg) {
            this._maybeGetLocationsFromSessionStorage();
            if (!this.organisation?.locations || this.organisation.locations.length == 0) {
                await this._fetchLocations();
            }
            else {
                this._fetchLocations();
            }
            this._locationData = this.organisation.locations;
            this._loading = false;
        }
        if (!this.provisions?.length) {
            this._getProvisionsFromSessionStorage();
            if (!this.provisions?.length) {
                await this._fetchProvisions();
            }
        }
        if (this.organisation?.hasOwnProperty('locations') && this.provisions?.length) {
            this._loading = false;
        }
        this._isApproved = this.organisation?.approvalStatus == 'Approved';
        this._subscriptionTier = this.organisation?.subscriptionTier ? this.organisation.subscriptionTier : 'Tier1';
        this._subscriptionTotalLocations = this.organisation?.subscriptionTotalLocations ? this.organisation.subscriptionTotalLocations : 1;
        this._subscriptionExpired = this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) < new Date();
        this._isPilot = this.organisation?.pilot;
        this._locationCount = this._locationData?.length || 0;
        this.renderRoot.querySelector('button,a')?.focus();
        cardLinks(this.shadowRoot);
        if (this.currentOrg && this._isAdmin()) {
            this._fetchInvoices();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    render() {
        let main = '';
        if (this._loading) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            let cards = html `<p>No locations have been added yet</p>`;
            let buttonString = `Add a location`;
            let notification = '';
            if (this._invoices) {
                let unpaidInvoices = this._invoices?.data?.filter((invoice) => invoice.status == 'open');
                if (unpaidInvoices?.length > 0) {
                    notification = html `<div class="message">\n                        <h4>You have ${unpaidInvoices.length == 1 ? 'an ' : ''}unpaid invoice${unpaidInvoices.length == 1 ? '' : 's'}</h4>\n                        <ul>\n                           ${unpaidInvoices.map((invoice) => html `\n                            <li>\n                                You have an unpaid invoice. Please make the payment in order to unlock the subscription benefits. \n                                <a href="${invoice.hostedInvoiceUrl}" target="_blank" rel="noopener">\n                                    View invoice\n                                </a>\n                            </li>`)}\n                        </ul>\n                    </div>`;
                }
            }
            if (this._locationData?.length) {
                buttonString = `Add another location`;
                cards = html `\n                    <ul>\n                        ${this._locationData.map((location) => {
                    let name = decodeEntities(location.name);
                    let id = location.id;
                    let in_progress = location.in_progress;
                    let isLocked = location.isLocked;
                    location = location.location_data;
                    if (!location)
                        return;
                    let status = location.approvalStatus ? getStatus(location.approvalStatus) : '';
                    let accessInfo = '';
                    if (location?.accessInformation) {
                        accessInfo = this._processAccessInfo(location.accessInformation);
                    }
                    let imageName;
                    for (let i = 1; i < 4; i++) {
                        if (location[`photo${i}`]) {
                            imageName = `photo${i}`;
                            break;
                        }
                    }
                    let image = location[imageName] ? location[imageName] : '';
                    let path = image ? location[imageName].publicUrl : '';
                    let alt = image ? location[imageName].altText : '';
                    let notices = location.declineMessage ? html `<div class="notices">\n                                    <span class="screen-reader-text">\n                                        ${location.declineMessage ? `You have a notice relating to ${organisation.name}` : ''}\n                                    </span>\n                                    <span aria-hidden="true" >${location.declineMessage ? '1' : ''}</span>\n                                </div>` : '';
                    let buttonGroup = html `\n                                <div class="button-group">\n                                    <a href="javascript:void(0)" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleLocationClick}>View location</a>\n                                    <a href="javascript:void(0)" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleLocationDetailsClick}>Manage details</a>\n                                </div>\n                            `;
                    if (location.approvalStatus == 'AwaitingResponse') {
                        buttonGroup = html `\n                                <div class="button-group">\n                                    <a href="javascript:void(0)" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleLocationClick}>View location</a>\n                                </div>\n                            `;
                    }
                    if (in_progress && location.approvalStatus == 'NewApplication') {
                        console.log(location.approvalStatus);
                        status = `New application in progress`;
                        if (isLocked) {
                            buttonGroup = html `\n                                    <div class="button-group">\n                                        <p >This form is currently being edited by someone else</p>\n                                    </div>\n                                    `;
                        }
                        else {
                            buttonGroup = html `\n                                    <div class="button-group">\n                                        <a href="javascript:void(0)" class="button" @click=${this._handleAddLocationClickContinue} data-locid="${id}" data-ppage="${in_progress}">Complete saved form</a>\n                                    </div>\n                                    `;
                        }
                    }
                    let inlineNotice = '';
                    if (location.approvalStatus == 'Rejected') {
                        inlineNotice = location.declineMessage ? html `<div class="notices">\n                                    <p>${location.declineMessage}</p>\n                                </div>` : '';
                        buttonGroup = '';
                        notices = '';
                    }
                    let zones = location.zones;
                    let zonesText = '';
                    if (location.approvalStatus == "Approved") {
                        let hasInProgressZones = zones.some(zone => zone.in_progress);
                        let hasActiveSubscription = this.organisation.subscriptionTier && this.organisation.subscriptionTier !== 'Tier1' && !this._subscriptionExpired;
                        zonesText = html `\n                                    <div class="content-zones">\n                                        <h4>Zones</h4>\n                                        <ul class="zone-list">\n                                            ${zones.map((zone, index) => {
                            let link;
                            let status = getStatus(zone.approvalStatus);
                            if (zone.in_progress) {
                                link = html `<a href="${this.hardlinks.organisation_dashboard_add_zone}?org_id=${this.currentOrg}&location_id=${id}&in_progress=${zone.id}&ppage=${zone.in_progress}">Complete your zone setup</a>`;
                            }
                            else {
                                link = html `<a href="javascript:void(0)" data-zone_id="${zone.id}" data-location_id="${id}" data-org_id="${this.currentOrg}" @click=${this._handleZoneClick}>Manage</a>`;
                            }
                            return html `\n                                                <li>\n                                                   ${zone.name} \n                                                   ${status ? html `<span class="message small">${status}</span>` : ''}\n                                                   ${link}\n                                                </li>\n                                            `;
                        })}\n                                        </ul>\n                                        ${!hasInProgressZones && hasActiveSubscription ? html `\n                                            <div class="button-group">\n                                                <a href="${this.hardlinks.organisation_dashboard_add_zone}?org_id=${this.currentOrg}&location_id=${id}">${zones.length ? `Add another zone` : `Add a zone`}</a>\n                                            </div>\n                                        ` : ''}\n                                        ${!hasActiveSubscription ? html `\n                                            <div class="message small">\n                                                <p>Zones are available for organisations on an active subscription plan. Please upgrade your subscription to access zone features.</p>\n                                                <br>\n                                                <button class="button" @click=${() => this._updateContext({ dashboard: 'subscriptions', panel: null, view: null })}>View subscription options</button>\n                                            </div>\n                                        ` : ''}\n                                    </div>\n                                `;
                    }
                    if (this._subscriptionTier !== "Tier1") {
                        let displayLocPublishedStatus;
                        if (location.approvalStatus == "AwaitingResponse") {
                            displayLocPublishedStatus = html `\n                                        <p class="published-status small">Awaiting approval</p>\n                                    `;
                        }
                        else if (location.approvalStatus == "NewApplication") {
                            displayLocPublishedStatus = html `\n                                        <p class="published-status small">New application</p>\n                                    `;
                        }
                        else {
                            displayLocPublishedStatus = html `\n                                        <p class="published-status small">\n                                            ${location.publishedStatus === 'Published' ? 'Published' : 'Unpublished'}\n                                        </p>\n                                    `;
                        }
                        return html `\n                                    <li class="bg location-card card">\n                                        <img src="${path}" alt="${alt}">\n                                        <div class="content">\n                                            <h4>${name}</h4>\n                                            ${displayLocPublishedStatus}\n                                            <p class="semibold">${accessInfo}</p>\n                                            ${buttonGroup}\n                                            ${inlineNotice}\n                                            ${zonesText}\n                                        </div>\n                                        \n                                        \n                                    </li>\n                                `;
                    }
                    else {
                        return html `\n                                    <li class="bg location-card card">\n                                        <img src="${path}" alt="${alt}">\n                                        <div class="content">\n                                            <h4>${name}</h4>\n                                            <p class="message small ${location.approvalStatus.toLowerCase()}">Please subscribe to an Essentials or Plus account to publish your location.</p>\n                                            <p class="semibold">${accessInfo}</p>\n                                            ${buttonGroup}\n                                            ${inlineNotice}\n                                            ${zonesText}\n                                        </div>\n                                        \n                                        \n                                    </li>\n                                `;
                    }
                })}\n                    </ul>\n                `;
            }
            let button = ``;
            if (this._isApproved) {
                if (this._subscriptionTotalLocations <= this._locationCount) {
                    button = '';
                }
                else {
                    button = html `<a href="javascript:void(0)" class="button" @click=${this._handleAddLocationClick}>${buttonString}</a>`;
                }
            }
            main = html `\n                <div class="grid">\n                    <h3>${decodeEntities(this.organisation?.name ?? '')} locations and zones</h3>\n                    ${cards}\n                    ${button}\n                </div>\n            `;
        }
        return html `${main}`;
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    _handleAddLocationClick(e) {
        e.preventDefault();
        //prevent add location for expired subscriptions
        const isActive = this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) > new Date();
        const btnContainer = e.currentTarget.parentElement;
        // Remove existing error message if any
        const existingMsg = btnContainer.querySelector('.add-location-error');
        if (existingMsg)
            existingMsg.remove();
        if (!isActive && this._subscriptionTier !== "Tier1") {
            // Append <p> below the button
            const p = document.createElement('p');
            p.className = 'add-location-error';
            p.textContent = 'Your subscription has expired. Please renew your subscription.';
            p.style.color = 'red';
            p.style.marginTop = '0.5rem';
            btnContainer.appendChild(p);
            return; // stop further action
        }
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'locations', panel: `add` });
    }
    _handleAddLocationClickContinue(e) {
        e.preventDefault();
        //prevent add location for expired subscriptions
        const isActive = this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) > new Date();
        const btnContainer = e.currentTarget.parentElement;
        // Remove existing error message if any
        const existingMsg = btnContainer.querySelector('.add-location-error');
        if (existingMsg)
            existingMsg.remove();
        if (!isActive && this._subscriptionTier !== "Tier1") {
            // Append <p> below the button
            const p = document.createElement('p');
            p.className = 'add-location-error';
            p.textContent = 'Your subscription has expired. Please renew your subscription.';
            p.style.color = 'red';
            p.style.marginTop = '0.5rem';
            btnContainer.appendChild(p);
            return; // stop further action
        }
        let id = e.target.dataset.locid;
        let ppage = e.target.dataset.ppage;
        window.location.href = `/organisation-dashboard/add-location?org_id=${this.currentOrg}&in_progress=${id}&ppage=${ppage}`;
    }
    _handleLocationClick(e) {
        e.preventDefault();
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'locations', panel: `${e.target.dataset.location_id}` });
    }
    _handleLocationDetailsClick(e) {
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'locations', panel: `${e.target.dataset.location_id}`, view: 'edit' });
    }
    // for handling zones
    _handleZoneClick(e) {
        e.preventDefault();
        const zoneId = e.currentTarget.dataset.zone_id;
        const locationId = e.currentTarget.dataset.location_id;
        const orgId = e.currentTarget.dataset.org_id;
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'locations', panel: `${locationId}`, view: zoneId });
    }
    async _handleContextUpdate(value) {
        let currentOrg = this.currentOrg;
        this.organisationData = value;
        ({ currentOrg: this.currentOrg, name: this.name, restUrl: this.restUrl, organisations: this.organisations, action: this.action, nonce: this.nonce, user: this.currentUser, provisions: this.provisions } = this.organisationData);
        this.organisation = this._getOrganisationById(this.currentOrg);
        //  prevent navigating to the add location page when subscription is expired
        // if (this.organisation?.subscriptionEndDate) {
        //     const isActive = new Date(this.organisation.subscriptionEndDate) > new Date();
        //     if (!isActive) {
        //         window.location.href = `/organisation-dashboard/${this.currentOrg}/subscriptions/`;
        //         return; // stop everything
        //     }
        // }
        if (this.organisation?.hasOwnProperty('locations')) {
            this._locationData = this.organisation.locations;
            if (this.provisions.length) {
                this._loading = false;
            }
            else {
                await this._fetchProvisions();
            }
        }
        else if (this.currentOrg !== currentOrg && this.currentOrg) {
            this._fetchLocations();
        }
    }
    _processAccessInfo(info) {
        //info = JSON.parse(info);
        return '';
    }
    static styles = [
        accessibility,
        grid,
        css `
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
            margin-bottom:1rem;
            
        }
        @media screen and (min-width:700px){
            .bg{
                grid-template-columns: auto 1fr 2rem;
            }
        }
        .button{
            text-align:center;
        }
        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:0rem;
            border-radius:0;
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            text-align:center;
            font-weight:700;
            text-decoration:underline;
            transition:color var(--transition) ease;
            height:fit-content;
            align-self:start;
            text-underline-offset: 6px;
        }

        .card:hover a{
            color:var(--allin-highlight-color-lighter,#5e3e7d);
        }

        .card a::after{
            content: "";
            display: inline-block;
            width: 21px;
            height: 15px;
            background: url('/wp-content/themes/ace/assets/arrow.svg') no-repeat center;
            background-size: cover;
            margin-left: 12px;
            transform: translateY(3px);
        }

        .content{
            display:grid;
            gap:0.5rem;
            padding: var(--allin-padding,2rem);
        }
        .content-zones{
            display:grid;
            gap:0.5rem;
            padding: 2rem 0 0;
        }
        .card img{
            object-fit:contain;
        }
        .bg.card.location-card {
            padding: 0;
        }
        .card.location-card img {
            object-fit: cover;
            width: 260px;
            height: 100%;
            aspect-ratio: 1;
        }
        h4,h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            /* justify-content:space-between; */
            gap:0.7rem;
            flex-direction: column;
        }

        .button-group button svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
    
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        ul li{
            display:grid;
            gap:0.5rem;
        }

        .button{
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            font-family:var(--allin-font-family,'Montserrat');
            background-color:var(--allin-button-bg-color,#472961);
            font-size:var(--allin-button-font-size,1rem);
            color:var(--allin-button-text-color,#fff);
            font-weight:(var(--allin-button-font-weight,600));
            cursor:pointer;
            border:none;
            text-decoration:none;
            transition:background-color var(--transition) ease;
        }

        ul.zone-list li{
            grid-template-columns: 1fr auto;
            border-top: 1px solid gray;
            border-bottom: 1px solid gray;
            padding: 0.5rem 0;
            font-weight: bold;

        }
        ul.zone-list li .message{
            grid-row: 2 / 3;
            grid-column: 1 / -1;
            font-weight: 400;
        }
        ul.zone-list li a {
            justify-self: end;
            font-size: 0.9rem;
        }
        ul.zone-list li a::after{
            content: none;
            background: none;
        }
        

        `
    ];
}
